export default {
  /*
   * index() lista los municipios
   */
  current(params) {
    return Vue.http.get('public_current_app_config', {params}).then(response => response.data.data)
  }
}
